if (!customElements.get("lsg-frequency-selector")) customElements.define("lsg-frequency-selector", class LSGFrequencySelector extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                input: ".js-lsg-frequency-selector-input",
                parent: "lsg-buybox-rebuild"
            };
            this.parent = this.closest(this.selectors.parent);
            this.init();
        }

        init() {
            if (this.parent != null) {

                this.addEventListener('change', () => {
                    this.parent.classList.remove('lsg-buybox-rebuild--frequency-selector-otp');
                    this.parent.classList.remove('lsg-buybox-rebuild--frequency-selector-sub');
                    this.parent.classList.add(`lsg-buybox-rebuild--frequency-selector-${this.querySelector(`${this.selectors.input}:checked`).value}`);

                })
                this.parent.classList.add(`lsg-buybox-rebuild--frequency-selector-${this.querySelector(`${this.selectors.input}:checked`).value}`);
            }
        }
    }
)
;
